<template comment="日查月、月查年、年查年">
  <div class="search-row">
    <div class="search-el-row flex-row" :gutter="12">
      <div class="tabs-wrap" :span="dataTypes.length > 3 ? 8 : 4">
        <compTab @change="handleDataTypeChange" :options="dataTypes"></compTab>
      </div>
      <!-- <el-col :span="4">
         <el-select v-model="dataType" @change="handleDataTypeChange">
          <el-option
            v-for="item in dataTypes"
            :key="item.id"
            :label="item.i18nValue"
            :value="item.dictKey">
          </el-option>
         </el-select>
      </el-col> -->

      <!-- <el-col :span="6"> -->
        
        <div class="search-row-date-picker" style="display: flex; align-items: center; min-height: 40px;">
          <div class="divider"></div>
          <!-- <div class="timelabel">{{ Lang.label.selectDate }}</div> -->
          <div v-if="!acrossTimePeriod">
            <el-date-picker
              v-if="dataType < 6"
              :clearable="false"
              size="default"
              v-model="datetime"
              type="date"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
              :disabled-minutes="disabledMinutes"
              :placeholder="Lang.label.selectDate">
            </el-date-picker>
            <el-date-picker
              v-if="dataType == 6"
              :clearable="false"
              v-model="datetime"
              type="month"
              value-format="YYYY-MM"
              format="YYYY-MM"
              :default-value="new Date()"
              :default-time="new Date()"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              v-if="dataType == 7"
              :clearable="false"
              v-model="datetime"
              type="year"
              value-format="YYYY"
              format="YYYY"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              v-if="dataType == 8"
              :clearable="false"
              v-model="daterange"
              type="yearrange"
              value-format="YYYY"
              format="YYYY"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
          </div>
          <div v-else>
            <el-date-picker
              v-if="dataType < 5"
              :clearable="false"
              size="default"
              v-model="daterange"
              type="datetimerange"
              value-format="YYYY-MM-DD HH:mm"
              format="YYYY-MM-DD HH:mm"
              @change="handleChange"
              @focus="handleFocus(3)"
              :picker-options="pickerOptions"
              :minutes-step="15"
              :disabled-minutes="pickerOptions.disabledMinutes"
              :disabled-date="pickerOptions.disabledDate"
              :placeholder="Lang.label.selectDate">
            </el-date-picker>
            <el-date-picker
              v-if="dataType == 5"
              :clearable="false"
              size="default"
              v-model="daterange"
              type="datetimerange"
              value-format="YYYY-MM-DD HH:mm"
              format="YYYY-MM-DD HH:mm"
              @change="handleChange"
              @focus="handleFocus(5)"
              :picker-options="pickerOptions"
              :disabled-minutes="pickerOptions.disabledAllMinutes"
              :disabled-date="pickerOptions.disabledDate"
              :placeholder="Lang.label.selectDate">
            </el-date-picker>
            <el-date-picker
              v-if="dataType == 6"
              :clearable="false"
              v-model="daterange"
              type="daterange"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
              :default-value="new Date()"
              :default-time="new Date()"
              @change="handleChange"
              @focus="handleFocus(6)"
              :picker-options="pickerOptions"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              v-if="dataType == 7"
              :clearable="false"
              v-model="daterange"
              type="monthrange"
              value-format="YYYY-MM"
              format="YYYY-MM"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              v-if="dataType == 8"
              :clearable="false"
              v-model="daterange"
              type="yearrange"
              value-format="YYYY"
              format="YYYY"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
          </div>
        </div>
      <!-- </el-col> -->
      <!-- <el-col :span="4"> -->
        <div class="arrow-box">
          <div class="pre" @click="handleClickPre">
            <comp-svg name="arrow-left-fill" size="14px" style="margin-left: -2px;"></comp-svg>
          </div>
          <div class="next" @click="handleClickNext">
            <comp-svg name="arrow-right-fill" size="14px"></comp-svg>
          </div>
          <div class="divider"  v-if="dataType != 8"></div>
        </div>
      <!-- </el-col> -->
      <div :span="2" style="font-weight:500;color:#192434;" v-if="dataType != 8">
        <el-checkbox v-model="acrossTimePeriod" @change="resetDefaultValue(true)" :label="Lang.label.acrossTimePeriod" size="large" />
      </div>
      <div v-if="showCompareType" :span="4">
        <el-select clearable v-model="compareType" @change="handleChange">
          <el-option
            v-for="item in compareTypes"
            :key="item.id"
            :label="item.i18nValue"
            :value="item.dictKey">
          </el-option>
        </el-select>
      </div>
      <!-- <el-col :span="2">
        <comp-button
          icon="icon-Search"
          type="default"
          @click="handleChange(true)">
          {{ Lang.btn.search }}
        </comp-button>
      </el-col> -->
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted } from "vue";
  import compTab from '@/components/comp-tab/index.vue';
  // import { dataTimeTypes } from '@/const/options';
  import dayjs from 'dayjs';
  import { getDictionary } from '@/api/system/dict';
  import { Lang } from "@/lang/lang";
  import { ElMessage } from 'element-plus';

  const props = defineProps(['isAnalysis', 'JFPG', 'showCompareType', 'page'])
  const compareTypes = ref([]);
  const dataTypes = ref([]);

  const acrossTimePeriod = ref(false);

  const now = dayjs()
  const current = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
  const oneHourBefore = now.subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
  const oneDayBefore = now.subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
  const oneMonthBefore = now.subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss');
  const foreYearBefore = now.subtract(4, 'year').format('YYYY-MM-DD HH:mm:ss');
  const dayBegin = now.startOf('day').format('YYYY-MM-DD HH:mm:ss');
  const daterange = ref([dayBegin, current]);
  const recordDateRange = ref([dayBegin, current]); // 用于恢复
  const datetime = ref(current);
  const dataType = ref('3'); // 1分钟 2:5分钟 3:15分钟 4:30分钟 5:小时 6:日 7:月 8:年
  const compareType = ref('0'); // 0 否 
  const emit = defineEmits(['change'])
  // const filterDataTypes = dataTimeTypes.filter(item => item.show);
  // const dataTypes = ref(filterDataTypes);

  function allowedMinutes(time) {
      const minutes = time.getMinutes();
      return [0, 15, 30, 45].includes(minutes);
    }
  const pickerOptions = ref({
    disabledDate: (time) => {
      const now = new Date().getTime();
      const times = new Date(time).getTime();
      // 不可选择超过今天的日期
      if (times > now) {
        return true
      }
      return false
    },
    minutesStep: 15,
    disabledMinutes(time) {
      const disabledMinutes = [];
      for (let i = 0; i < 60; i++) {
        if (i % 15 !== 0) { // 禁用!每15分钟
          disabledMinutes.push(i);
        }
      }
      return disabledMinutes;
    },
    disabledAllMinutes(time) {
      const disabledMinutes = [];
      for (let i = 0; i < 60; i++) {
        disabledMinutes.push(i);
      }
      return disabledMinutes;
    },
  })
  
  const disabledMinutes = (hour) => {
    let minTime = props.options.rqMin || '00:00:00';
    let maxTime = props.options.rqMax || '23:59:59';
  
    const { hour: minHour, minute: minMinute } = parseTime(minTime);
    const { hour: maxHour, minute: maxMinute } = parseTime(maxTime);
  
    if (hour === minHour) {
      return makeRange(0, minMinute - 1);
    } else if (hour === maxHour) {
      return makeRange(maxMinute + 1, 59);
    } else {
      return [];
    }
  };

  const getTime = () => {
    const values = daterange.value;
    let stime = null;
    let etime = null;

    if (values) {
      stime = values[0];
      etime = values[1];
      

      if (new Date(stime).getTime() > new Date().getTime()) {  // 开始时间大于当前时间取当前时间
        stime = dayjs(new Date().getTime())
      }
      if (acrossTimePeriod.value) { // 跨时间段
        if (stime) {
          stime = dayjs(stime).startOf('day')
          if (dataType.value == 5) { // 小时
            stime = dayjs(stime).startOf('day')
            // etime = dayjs(etime).endOf('day') 取整小时默认的
          } else if (dataType.value == 6) { // 日报
            stime = dayjs(stime).startOf('day')
            etime = dayjs(etime).endOf('day')
          } else if (dataType.value == 7) { // 月报
            stime = dayjs(stime).startOf('month')
            etime = dayjs(etime).endOf('month')
          } else if (dataType.value == 8) { // 年报
            stime = dayjs(stime).startOf('year')
            etime = dayjs(etime).endOf('year')
          }
        }
      } else { // 不跨时间段
        if (dataType.value != 8) { // 非范围时间从datetime中获取
          stime = datetime.value;
        }
        if (stime) {
          if (dataType.value < 6 ) { // 小时以内
            stime = dayjs(stime).startOf('day')
            etime = dayjs(etime).endOf('day')
          } else if (dataType.value == 6) { // 日报 显示当前的月份
            stime = dayjs(stime).startOf('month')
            etime = dayjs(etime).endOf('day')
          } else if (dataType.value == 7) { // 月报 显示当前的年份
            stime = dayjs(stime).startOf('year')
            etime = dayjs(stime).endOf('year')
          } else if (dataType.value == 8) { // 年报 显示当前的年份范围
            stime = dayjs(stime).startOf('year')
            etime = dayjs(etime).endOf('year')
          }
        }
      }
      // if (new Date(etime).getTime() > new Date().getTime()) {  // 结束时间大于当前时间取当前时间
      //   etime = dayjs(new Date().getTime())
      // }
      // 统一格式化时间
      stime = dayjs(stime).format("YYYY-MM-DD HH:mm:ss")
      etime = dayjs(etime).format("YYYY-MM-DD HH:mm:ss")
      return {
        stime,
        etime
      }
    }
  }
  // 点击前一个时间
  function handleClickPre() {
    const values = daterange.value;
    let stime = null;
    let etime = null;
    let newStime = null;
    let newEtime = null;
    if (values) {
      stime = values[0];
      etime = values[1];
    }
    if (acrossTimePeriod.value) { // 跨时间段 需要保持时间间隔不变
      const diffTime = dayjs(etime).diff(dayjs(stime)); // 时间间隔 月和年不同
      stime = dayjs(stime)
      etime = dayjs(etime)
      newStime = dayjs(stime).subtract(diffTime, 'ms')
      newEtime = dayjs(etime).subtract(diffTime, 'ms')
      if (dataType.value < 5 ) { // 15分钟以内
        daterange.value = [newStime, newEtime];
      } else if (dataType.value == 5 ) { // 小时
        daterange.value = [newStime, newEtime];
        // 传参时间取值 是啥取啥
      } else if (dataType.value == 6) { // 日
        daterange.value = [newStime, newEtime];
        // 传参时间取值 是啥取啥
        newStime = dayjs(newStime).startOf('day') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('day') // 传参时间取值
      } else if (dataType.value == 7) { // 月
        const diffTime = dayjs(etime).diff(dayjs(stime), 'month'); // 时间间隔
        newStime = dayjs(stime).subtract(diffTime, 'month')
        newEtime = dayjs(etime).subtract(diffTime, 'month')
        daterange.value = [newStime, newEtime];
        newStime = dayjs(newStime).startOf('month') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('month') // 传参时间取值
      } else if (dataType.value == 8) { // 年
        const diffTime = dayjs(etime).diff(dayjs(stime), 'year'); // 时间间隔
        newStime = dayjs(stime).subtract(diffTime, 'year')
        newEtime = dayjs(etime).subtract(diffTime, 'year')
        daterange.value = [newStime, newEtime];
        newStime = dayjs(newStime).startOf('year') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('year') // 传参时间取值
      }
    } else {
      if (dataType.value != 8) { // 非范围时间从datetime中获取
        stime = datetime.value;
      }
      stime = dayjs(stime)
      etime = dayjs(etime)
      if (dataType.value < 5 ) { // 15分钟以内
        newStime = dayjs(stime).subtract(1, 'day').startOf('day')
        newEtime = dayjs(newStime).endOf('day')
        datetime.value = newStime;
      } else if (dataType.value == 5 ) { // 小时
        newStime = dayjs(stime).subtract(1, 'day').startOf('day')
        newEtime = dayjs(newStime).endOf('day')
        datetime.value = newStime;
      } else if (dataType.value == 6) { // 日
        newStime = dayjs(stime).subtract(1, 'month').startOf('month')
        newEtime = dayjs(newStime).endOf('month')
        datetime.value = newStime;
      } else if (dataType.value == 7) { // 月
        newStime = dayjs(stime).subtract(1, 'year').startOf('year')
        newEtime = dayjs(newStime).endOf('year')
        datetime.value = newStime;
      } else if (dataType.value == 8) { // 年
        const diffTime = dayjs(etime).diff(dayjs(stime), 'year'); // 时间间隔
        newStime = dayjs(stime).subtract(diffTime, 'year')
        newEtime = dayjs(etime).subtract(diffTime, 'year')
        daterange.value = [newStime, newEtime]; // 避免时间间隔变化
        newStime = dayjs(newStime).startOf('year') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('year') // 传参时间取值
      }
    }
    // const times = { 
      stime = dayjs(newStime).format('YYYY-MM-DD HH:mm:ss')
      etime = dayjs(newEtime).format('YYYY-MM-DD HH:mm:ss')
    // }
    const times = [ stime, etime ]
    handleChange(times)
  }
  // 点击后一个时间
  function handleClickNext() {
    const values = daterange.value;
    let stime = null;
    let etime = null;
    let newStime = null;
    let newEtime = null;
    if (values) {
      stime = values[0];
      etime = values[1];
    }
    if (acrossTimePeriod.value) { // 跨时间段 需要保持时间间隔不变
      const diffTime = dayjs(etime).diff(dayjs(stime)); // 时间间隔 月和年不同
      stime = dayjs(stime)
      etime = dayjs(etime)
      newStime = dayjs(stime).add(diffTime, 'ms')
      newEtime = dayjs(etime).add(diffTime, 'ms')
      if (dataType.value < 5 ) { // 15分钟以内
        daterange.value = [newStime, newEtime];
        // 传参时间取值 是啥取啥
      } else if (dataType.value == 5 ) { // 小时
        daterange.value = [newStime, newEtime];
        // 传参时间取值 是啥取啥
      } else if (dataType.value == 6) { // 日
        daterange.value = [newStime, newEtime];
        newStime = dayjs(newStime).startOf('day') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('day') // 传参时间取值
      } else if (dataType.value == 7) { // 月
        const diffTime = dayjs(etime).diff(dayjs(stime), 'month'); // 时间间隔
        newStime = dayjs(stime).add(diffTime, 'month')
        newEtime = dayjs(etime).add(diffTime, 'month')
        daterange.value = [newStime, newEtime];
        newStime = dayjs(newStime).startOf('month') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('month') // 传参时间取值
      } else if (dataType.value == 8) { // 年
        const diffTime = dayjs(etime).diff(dayjs(stime), 'year'); // 时间间隔
        newStime = dayjs(stime).add(diffTime, 'year')
        newEtime = dayjs(etime).add(diffTime, 'year')
        daterange.value = [newStime, newEtime];
        newStime = dayjs(newStime).startOf('year') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('year') // 传参时间取值
      }
    } else {
      if (dataType.value != 8) { // 非范围时间从datetime中获取
        stime = datetime.value;
      }
      stime = dayjs(stime)
      etime = dayjs(etime)
      if (dataType.value < 5 ) { // 15分钟以内
        stime = dayjs(stime)
        newStime = dayjs(stime).add(1, 'day').startOf('day')
        newEtime = dayjs(newStime).endOf('day')
        datetime.value = newStime;
      } else if (dataType.value == 5 ) { // 小时
        stime = dayjs(stime)
        newStime = dayjs(stime).add(1, 'day').startOf('day')
        newEtime = dayjs(newStime).endOf('day')
        datetime.value = newStime;
      } else if (dataType.value == 6) { // 日
        newStime = dayjs(stime).add(1, 'month').startOf('month')
        newEtime = dayjs(newStime).endOf('month')
        datetime.value = newStime;
      } else if (dataType.value == 7) { // 月
        newStime = dayjs(stime).add(1, 'year').startOf('year')
        newEtime = dayjs(newStime).endOf('year')
        datetime.value = newStime;
      } else if (dataType.value == 8) { // 年
        const diffTime = dayjs(etime).diff(dayjs(stime), 'year'); // 时间间隔
        newStime = dayjs(stime).add(diffTime, 'year')
        newEtime = dayjs(etime).add(diffTime, 'year')
        daterange.value = [newStime, newEtime]; // 避免时间间隔变化
        newStime = dayjs(newStime).startOf('year') // 传参时间取值
        newEtime = dayjs(newEtime).endOf('year') // 传参时间取值
      }
    }
    // const times = { 
      stime = dayjs(newStime).format('YYYY-MM-DD HH:mm:ss')
      etime = dayjs(newEtime).format('YYYY-MM-DD HH:mm:ss')
    // }
    const times = [ stime, etime ]
    handleChange(times)
  }
  function handleDataTypeChange(i, item) {
    dataType.value = item.dictKey;
    // 类型变换重置时间选择器初始化值
    resetDefaultValue()
    handleChange()
  }

  function roundToNearestQuarterHour(dateTimeStr) { // 取整%15分钟类型
    const date = new Date(dateTimeStr);

    const minutes = date.getMinutes();
    const roundedMinutes = Math.floor(minutes / 15) * 15;

    date.setMinutes(roundedMinutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const mins = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${mins}:00`;
}
  function getCurrentHourStart() {
      const now = new Date();

      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:00:00`;
  }


  function resetDefaultValue(search) {
    const roundCurrent = roundToNearestQuarterHour(current);
    const roundHour =  getCurrentHourStart(current);
    datetime.value = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
    daterange.value = [dayBegin, roundCurrent]
    if (!acrossTimePeriod.value) {
      if (dataType.value == 8) { // 非跨时间段年报显示前4年和当前年
        daterange.value = [foreYearBefore, current]
      }
    } else {
      if (dataType.value == 3) { // 15分钟
        daterange.value = [dayjs(current).startOf('day'), roundCurrent] // 默认今天0点到当前时间的近一次00、15、30、或45分钟
      } else  if (dataType.value == 5) { // 小时
        daterange.value = [dayjs(current).startOf('day'), roundHour] // 默认今天0点到当前时间整点
      } else  if (dataType.value == 6) { // 日
        daterange.value = [dayjs(current).startOf('month'), current] // 默认本月1号至今天
      } else if (dataType.value == 7) {  // 月
        daterange.value = [dayjs(current).startOf('year'), current] // 默认本年1月到当前月
      } else if (dataType.value == 8) { // 年
        daterange.value = [foreYearBefore, current] // 跨时间段年报显示前4年和当前年
      }
    }
    if (search) {
      handleChange()
    }
  }
  function handleFocus(value) {
    recordDateRange.value = daterange.value;
    console.log('record', recordDateRange.value)
    // 记录上次时间
  }
  function handleChange(newTimes) {
    // if (flag !== true) { // 不是点击查询按钮
    //   return
    // }
    let times = getTime() // 获取时间;
    let stime = null;
    let etime = null;
    if (Array.isArray(newTimes)) {
      stime = newTimes[0];
      etime = newTimes[1];
    } else {
      stime = times.stime;
      etime = times.etime;
    }
    if (acrossTimePeriod.value) {
      // 分钟的时间跨度不可以超过1天  minuteAcrossLimitOneDay
      // 小时的时间跨度不可以超过31天 hourAcrossLimitThirtyDay
      // 天的时间跨度不可以超过365天 dayAcrossLimit365day
      if (dataType.value < 5) { // 分钟
        if (dayjs(etime).diff(dayjs(stime), 'minute') > 60*24) { // 用分钟算1天
          ElMessage({ type: 'error', message: Lang.tips.minuteAcrossLimitOneDay });
          daterange.value = recordDateRange.value;
          return
        }
      } else if (dataType.value == 5) { // 小时
        if (dayjs(etime).diff(dayjs(stime), 'day') > 31) {
          ElMessage({ type: 'error', message: Lang.tips.hourAcrossLimitThirtyDay });
          daterange.value = recordDateRange.value;
          return
        }
      } else if (dataType.value == 6) { // 日报
        if (dayjs(etime).diff(dayjs(stime), 'day') > 365) {
          ElMessage({ type: 'error', message: Lang.tips.dayAcrossLimit365day });
          daterange.value = recordDateRange.value;
          return
        }
      }
      // 跨时间段结束时间判断
      if (dataType.value < 5) { // 分钟
        // etime = dayjs(etime).endOf('minute')
      } else if (dataType.value == 5) { // 小时
        // etime = dayjs(etime).endOf('hour')
      } else if (dataType.value == 6) { // 日报
        etime = dayjs(etime).endOf('day')
      } else if (dataType.value == 7) { // 月报
        etime = dayjs(etime).endOf('month')
      } else if (dataType.value == 8) { // 年报
        etime = dayjs(etime).endOf('year') // 范围特殊
      }
    } else {
      // 非跨时间段结束时间判断
      if (dataType.value < 5) { // 分钟
        etime = dayjs(stime).endOf('day')
      } else if (dataType.value == 5) { // 小时
        etime = dayjs(stime).endOf('day')
      } else if (dataType.value == 6) { // 日报
        etime = dayjs(stime).endOf('month')
      } else if (dataType.value == 7) { // 月报
        etime = dayjs(stime).endOf('year')
      } else if (dataType.value == 8) { // 年报
        etime = dayjs(etime).endOf('year') // 范围特殊
      }
    }
    stime = dayjs(stime).format('YYYY-MM-DD HH:mm:ss')
    etime = dayjs(etime).format('YYYY-MM-DD HH:mm:ss')
    times = { stime, etime }
    emit('change', {
      dataType: dataType.value,
      compareType: compareType.value,
      ...times,
    })
  }

  function getParams() {
    const times = getTime()
    return {
      dataType: dataType.value,
      compareType: compareType.value,
      ...times,
    }
  }

  function getCompareTypes() {
    getDictionary({code: 'compareType'}).then(res => {
      if (res.data.code === 200) {
        const data = res.data.data || []
        if (props.isAnalysis) {
          compareTypes.value = data.filter(item => item.dictKey != 3)
        } else {
          compareTypes.value = data;
        }
        compareType.value = compareTypes.value[0].dictKey;
      }
    })
  }

  function getJFPGTypes() {
    getDictionary({code: 'jfpg'}).then(res => {
      if (res.data.code === 200) {
        const data = res.data.data || []
        compareTypes.value = data;
        compareType.value = ''
      }
    })
  }

  onMounted(() => {
    if (props.JFPG) {
      getJFPGTypes();
    } else {
      getCompareTypes();
    }
    getDictionary({code: 'dataType'}).then(res => {
      const data = res.data.data;
      if (res.data.code === 200) {
        if (props.JFPG) {
          dataTypes.value = data.filter(item => {
            return ['5','6','7'].includes(item.dictKey)
          })
        } else if (props.page === 'energyFlow') {
          const values = data.filter(item => {
            return ['5','6','7'].includes(item.dictKey)
          })
          console.log(values)
          dataTypes.value = values;
        } else {
          dataTypes.value = data.filter(item => {
            return ['3','5','6','7','8'].includes(item.dictKey)
          })
          // dataTypes.value = data;
        }
        dataType.value = dataTypes.value[0].dictKey;
      }
    })
    if (daterange.value) {
      handleChange();
    }

    pickerOptions.onSelect = (time) => {
      if (!allowedMinutes(time)) {
        const newMinutes = [0, 15, 30, 45].reduce((prev, curr) => {
          return Math.abs(curr - minutes) < Math.abs(prev - minutes) ? curr : prev;
        }, Infinity);
        time.setMinutes(newMinutes);
      }
    };
  })

  defineExpose({
    getParams,
    resetDefaultValue,
  })
</script>
<style lang="scss" scoped>

</style>